module.exports = __webpack_public_path__ + "static/img/theme_01.849f2751.png";